import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { environment } from 'src/environments/environment'

import { Character, CharacterCreateDto } from '@mmocld/data'

@Injectable({
  providedIn: 'root',
})
export class CharacterService {
  private url = environment.fdiHttpUrl

  constructor(private http: HttpClient) {}

  findAll() {
    return this.http.get<Character[]>(this.url + '/characters')
  }

  create(characterCreateDto: CharacterCreateDto) {
    return this.http.post<Character>(this.url + '/characters', characterCreateDto)
  }

  findOne(characterId: string) {
    return this.http.get<Character>(this.url + `/characters/${characterId}`)
  }

  delete(characterId: string) {
    return this.http.delete(this.url + `/characters/${characterId}`)
  }
}
